import PathGame from "./PathGame";

function FrogSprite(size = 34) {
  return (
    <span style={{ display: "inline-block", animation: "frogLeap 0.8s ease-in-out infinite" }}>
      <svg width={size} height={size * 0.9} viewBox="0 0 44 40" aria-hidden style={{ filter: "drop-shadow(0 3px 4px rgba(0,0,0,0.5))" }}>
        {/* rear legs extended in mid-leap */}
        <path d="M4 30 Q2 22 8 20 Q14 22 12 28 L18 30 L14 33 Z" fill="#166534" stroke="#0B0D10" strokeWidth="0.8" strokeLinejoin="round" />
        <path d="M40 30 Q42 22 36 20 Q30 22 32 28 L26 30 L30 33 Z" fill="#166534" stroke="#0B0D10" strokeWidth="0.8" strokeLinejoin="round" />
        {/* body — teardrop, tucked in during leap */}
        <ellipse cx="22" cy="26" rx="10" ry="7" fill="#22C55E" stroke="#0B0D10" strokeWidth="0.9" />
        <ellipse cx="22" cy="27" rx="7" ry="4" fill="#4ADE80" opacity="0.7" />
        {/* front legs — tucked forward */}
        <path d="M14 30 L11 34 L14 34 L17 32 Z" fill="#166534" stroke="#0B0D10" strokeWidth="0.6" strokeLinejoin="round" />
        <path d="M30 30 L33 34 L30 34 L27 32 Z" fill="#166534" stroke="#0B0D10" strokeWidth="0.6" strokeLinejoin="round" />
        {/* eye bulges */}
        <circle cx="15" cy="17" r="5" fill="#22C55E" stroke="#0B0D10" strokeWidth="0.9" />
        <circle cx="29" cy="17" r="5" fill="#22C55E" stroke="#0B0D10" strokeWidth="0.9" />
        <circle cx="15" cy="16" r="3" fill="#F8FAFC" />
        <circle cx="29" cy="16" r="3" fill="#F8FAFC" />
        <circle cx="16" cy="17" r="1.6" fill="#0B0D10" />
        <circle cx="30" cy="17" r="1.6" fill="#0B0D10" />
        <circle cx="16.5" cy="16" r="0.5" fill="#FFF" />
        <circle cx="30.5" cy="16" r="0.5" fill="#FFF" />
        {/* smile */}
        <path d="M16 26 Q22 30 28 26" stroke="#0B0D10" strokeWidth="0.9" fill="none" strokeLinecap="round" />
        {/* body highlight */}
        <path d="M17 22 Q22 20 27 22" stroke="#4ADE80" strokeWidth="0.8" fill="none" opacity="0.8" strokeLinecap="round" />
      </svg>
      <style>{`
        @keyframes frogLeap { 0%,100% { transform: translateY(0) rotate(-2deg); } 50% { transform: translateY(-4px) rotate(2deg); } }
      `}</style>
    </span>
  );
}

const RETRO_COLORS = ["#EF4444", "#F59E0B", "#10B981", "#3B82F6", "#A855F7"];
function PixelCar() {
  const c = RETRO_COLORS[Math.floor(Math.random() * RETRO_COLORS.length)];
  return (
    <svg width="28" height="42" viewBox="0 0 28 42" shapeRendering="crispEdges" aria-hidden>
      <rect x="4" y="4" width="20" height="34" fill={c} stroke="#0B0D10" strokeWidth="1" />
      <rect x="7" y="10" width="14" height="8" fill="#0B0D10" />
      <rect x="7" y="24" width="14" height="8" fill="#0B0D10" />
      <rect x="2" y="8" width="4" height="6" fill={c} stroke="#0B0D10" strokeWidth="1" />
      <rect x="22" y="8" width="4" height="6" fill={c} stroke="#0B0D10" strokeWidth="1" />
      <rect x="2" y="28" width="4" height="6" fill={c} stroke="#0B0D10" strokeWidth="1" />
      <rect x="22" y="28" width="4" height="6" fill={c} stroke="#0B0D10" strokeWidth="1" />
      <rect x="10" y="4" width="8" height="2" fill="#FFF8C5" />
    </svg>
  );
}
function RoadLane(_index, passed) {
  return (
    <>
      <div className="absolute inset-x-0 top-1/2 h-[3px] -translate-y-1/2 opacity-50"
        style={{background: "repeating-linear-gradient(90deg,#FDE68A 0 8px,transparent 8px 18px)"}} />
      {passed && <div className="absolute inset-0 bg-emerald-500/5" />}
    </>
  );
}

export default function Frogger() {
  return (
    <PathGame
      slug="frogger"
      title="Frogger"
      headline="Hop · dodge · repeat"
      icon={<span style={{ display: "inline-flex", width: 14, height: 14 }}>{FrogSprite(14)}</span>}
      actionVerb="Hop"
      laneWord="lane"
      playerSprite={FrogSprite}
      obstacleSprite={PixelCar}
      laneVariant={RoadLane}
      backgroundGradient="linear-gradient(180deg,#1F2937 0%,#111827 50%,#030712 100%)"
    />
  );
}
